import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { Horario } from "@/models/horario";
import { Observable } from "rxjs";
import { VeiculoAPI } from "@/api/veiculo.api";
import { Veiculo } from "@/models/veiculo";

const veiculoAPI = new VeiculoAPI();

const findBy = (cnpj: string, token: string): Observable<Veiculo[]> => {
  return veiculoAPI.findBy(cnpj, token);
};

const findById = (veiculoId: number): AxiosObservable<Veiculo> => {
  return veiculoAPI.findById(veiculoId);
};

const findByCnpjPaca = (
  cnpj: string,
  placa: string
): AxiosObservable<Veiculo> => {
  return veiculoAPI.findByCnpjPaca(cnpj, placa);
};

const findByVeiculoTransportadora = (
  veiculoTransportadoraId: number
): AxiosObservable<Veiculo> => {
  return veiculoAPI.findByVeiculoTransportadora(veiculoTransportadoraId);
};

export default {
  findBy,
  findById,
  findByCnpjPaca,
  findByVeiculoTransportadora
};
